import { render, staticRenderFns } from "./Validasi.vue?vue&type=template&id=20e0e8f3&"
import script from "./Validasi.vue?vue&type=script&lang=js&"
export * from "./Validasi.vue?vue&type=script&lang=js&"
import style0 from "./Validasi.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports